import React, { useState } from 'react'

import { useCart } from '../cart/index.jsx';
import { Alert, Button } from './ui';

const AddToCartButton = ({ listing, label = "Add to cart", className = '', variant = "primary" }) => {
  const [ reservedClicked, setReservedClicked ] = useState(false)
  const cart = useCart();

  if (!cart.available) {
    return null;
  }

  const onClick = () => {
    if (listing.is_reserved) {
      return setReservedClicked(true)
    }

    cart.add(listing)
  }

  if (reservedClicked) {
    return <Alert tone="warning">This product is currently under reservation.</Alert>
  }

  if (cart.has(listing)) {
    return (
      <Button to="/checkout" variant={variant} className={className} data-btn="checkout-open">
        Complete purchase
      </Button>
    );
  }

  return (
    <Button variant={variant} className={className} onClick={onClick} data-btn="cart-add">
      {label}
    </Button>
  )
}

export default AddToCartButton
